import { FormLayout } from '@expressable/syntax-ds';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormUi } from './formUi';
import { FormData, getLocalizedSchema } from './schema';
import { useRequestResetPasswordFormContext } from '../context';

type Props = {
  loading: boolean;
  onSubmit: SubmitHandler<FormData>;
};

export const RequestResetPasswordForm = ({ loading, onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { formClassname } = useRequestResetPasswordFormContext();

  const methods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(getLocalizedSchema(t)),
    disabled: loading,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <FormLayout onSubmit={handleSubmit(onSubmit)} className={formClassname}>
        <FormUi isLoading={loading} />
      </FormLayout>
    </FormProvider>
  );
};
